export default [
  {
    type: 'update_date',
    content: 'Updated at 22 December 2022',
  },
  {
    type: 'text',
    content:
      '<strong>1.1 </strong> These Terms and Conditions constitute a legally binding agreement between you (either personally or on behalf of an entity you represent) and Tamara FZE ("Tamara"), hereinafter referred to as "We", with respect to all aspects of the Tamara Payment Services and/or your use of the Platform or your access to our website https://tamara.co, as well as any other media form, media channel, website or mobile application related to, or linked to and through your access to and use of the Platform. You acknowledge that you have read, understood and agreed to be bound by these Terms and Conditions, as amended from time to time. if you do not agree to these terms and conditions, you must stop using or accessing the platform immediately and if you are using the platform on behalf of a third party including, without limitation, any business entity, you warrant that you are authorized and have the authority to commit the third party to these Terms and Conditions.',
  },
  {
    type: 'text',
    content:
      '<strong>1.2 </strong> The merchant from whom you purchase goods or services using Tamara Payment Services is not a party to this Agreement, and any applicable terms between you and the Merchant are independent of the terms of this Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>1.3</strong> We reserve the right, at our absolute discretion, to make changes or modifications to these Terms and Conditions at any time and for any reason.',
  },
  {
    type: 'text',
    content:
      '<strong>1.4</strong> You acknowledge your responsibility to review these terms and conditions periodically for the latest developments, and you waive any right to receive specific notice of each such change, and your continued use of the site and the platform after the date of publication of the revised terms and conditions constitutes an acknowledgment from you that you have read and understood the amendments and accepted the commitment.',
  },
  {
    type: 'text',
    content:
      '<strong>1.5</strong> This preamble is an integral part of the Agreement.',
  },
  {
    type: 'subtitle',
    content: '2. Definitions',
  },
  {
    type: 'text',
    content:
      'The following references, words, expressions and terms have the meanings set forth in front of each of them in these terms and conditions:',
  },
  {
    type: 'text',
    content:
      '<strong>2.1</strong> References to “You”: References to “you”, or the possessive pronoun “your” or other similar pronouns in this Agreement are references to the relevant Customer referred to in the identifying information (as defined below) to be provided prior to using the Services Payment from Tamara (as defined below).',
  },
  {
    type: 'text',
    content:
      '<strong>2.2</strong> References to “we”: References to “we” or “we” as a possessive, object, or other similar pronouns in this Agreement are references to Tamara and its affiliated entities and persons.',
  },
  {
    type: 'text',
    content:
      '<strong>2.3</strong> Website: means Tamara\'s website <a target="_blank" href="https://tamara.co">https://tamara.co</a>',
  },
  {
    type: 'text',
    content:
      '<strong>2.4</strong> Customer: means the customer of the “merchant or merchant platform” who creates a Tamara account.',
  },
  {
    type: 'text',
    content:
      '<strong>2.5</strong> Merchant: means any commercial entity that provides payment services from Tamara to its customers pursuant to an agreement between it and Tamara, or between Tamara and the merchant platform.',
  },
  {
    type: 'text',
    content:
      '<strong>2.6</strong> Merchant platform: means the means, including but not limited to websites and applications, which allow multiple merchants to offer goods and services to customers through a single platform.',
  },
  {
    type: 'text',
    content:
      '<strong>2.7</strong> Services: means the services provided by Tamara Company.',
  },
  {
    type: 'text',
    content:
      '<strong>2.8</strong> Purchase order: means the request submitted by the Customer through the platform, the merchant’s website, or any other applications or point of sale to use the Tamara payment service to purchase goods or services from the merchant.',
  },
  {
    type: 'text',
    content:
      '<strong>2.9</strong> Tamara Payment Service: The service that the Customer selects at the Merchant or on the Merchant Platform website or at any other point of sale with the Merchant or on the Merchant Platform under which the Customer chooses to purchase goods or services from the Merchant or Merchant Platform using the Tamara Services subject to this Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>2.10</strong> Tamara Account: means the account created by the Customer to use the Tamara Payment Services, whose use and operation will be subject to the terms and conditions of this Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>2.11</strong> Payment process: It means the process that the Customer goes through when choosing to use the payment services available by Tamara in connection with a specific purchase order.',
  },
  {
    type: 'text',
    content:
      '<strong>2.12</strong> Refund of payments: The amount paid by the Customer to the merchant by Tamara in connection with an approved transaction and then returned to the Customer following the dispute.',
  },
  {
    type: 'text',
    content:
      '<strong>2.13</strong> Dispute: Any request for refund, deduction, compensation, counterclaim or dispute of any kind by the Customer against the merchant in respect of the goods or services that resulted in an approved transaction.',
  },
  {
    type: 'text',
    content:
      '<strong>2.14</strong> Identification Information: means the information required to be provided by the Customer to Tamara in order to create an account for him with Tamara as collected by Tamara or the merchant or merchant platform for the purposes of providing Tamara Payment Services to Customers.',
  },
  {
    type: 'text',
    content:
      '<strong>2.15</strong> Transaction Information: Means all information related to the purchase order.',
  },
  {
    type: 'text',
    content:
      '<strong>2.16</strong> Net Amount: means the total amount to be paid by the Customer [including any value-added tax and shipping charges] in connection with a purchase order that gives rise to one approved transaction minus:',
  },
  {
    type: 'list',
    content: [
      '(a) Any returns.',
      '(b) Any deductions, credits or reductions claimed by the Customer and approved by the relevant merchant.',
    ],
  },
  {
    type: 'text',
    content:
      '<strong>2.17</strong> Force Majeure: It means any fatal event, or sudden event that cannot be foreseen and impossible to prevent, including, in general, but not limited to, fire, floods, storms, hurricanes, tornadoes, volcanic activities and earthquakes, as well as any actions, orders or requests issued by a sovereign authority, government and/or anybody that is supposed to work for that body. As well as war, whether declared or not, and behavior similar to war, revolutions, riots, civil disobedience, and civil disorder, as well as strikes, work stoppages, and/or similar situations, and any other similar cause that is beyond the control or control of any party’s control, unless its performance is the implementation of a warranty subject to an express waiver of exemption in the event of a force majeure event.',
  },
  {
    type: 'text',
    content:
      '<strong>2.18</strong> Applicable Laws: They mean the regulations in force in the Kingdom of Saudi Arabia that apply to the agreement.',
  },
  {
    type: 'subtitle',
    content: '3. Eligibility and Validity:',
  },
  {
    type: 'text',
    content:
      '<strong>3.1</strong> Your use of Tamara Payment Services is an acknowledgment of your legal and legal capacity to enter into this Agreement in accordance with these Terms and Conditions and a declaration by you that you are over the age of eighteen (18) years.',
  },
  {
    type: 'text',
    content:
      '<strong>3.2</strong> If you register as a business entity, legal person or any other entity, it is your acknowledgment that you have the necessary authority and capacity to enter into this agreement and to bind your entity to these terms and conditions, and that you, as well as the business entity, will comply with all applicable laws and requirements that apply to - and are subject to - for the process of using the website and using the payment services of Tamara.',
  },
  {
    type: 'text',
    content:
      '<strong>3.3</strong> By clicking to agree to the terms of this agreement, you acknowledge that you have entered into this agreement electronically in accordance with the regulations in force in the Kingdom of Saudi Arabia.',
  },
  {
    type: 'subtitle',
    content: '4. Accounts and Registration:',
  },
  {
    type: 'text',
    content:
      '<strong>4.1</strong> The process of registering the account and completing the agreement requires you to provide Tamara with certain personal information for the purposes of Know Your Customer applicable in the Kingdom, including, in general, but not limited to, your full name, address, email, phone number and age, you acknowledge and agree that the true, accurate, complete and even up-to-date information about you on the Account, and promptly notify Tamara of any changes to your personally identifiable information or any other information or circumstances that may affect your eligibility to continue to use Tamara Payment Services or are otherwise required in accordance with the terms of this Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>4.2</strong> You hereby agree to disclose all of your financial obligations and to refrain from withholding any information that may be impactful or important to any of the parties of the financing agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>4.3</strong> You hereby agree that you will be responsible for all activity under your account and agree to maintain and maintain security for your account username and password on an ongoing basis, unless you express otherwise in writing.',
  },
  {
    type: 'text',
    content:
      '<strong>4.4</strong> If your password is lost or stolen, or if you believe that there is unauthorized access to your Tamara account, you must change the password for your Tamara account and notify us immediately. The Customer is responsible for any transactions made using his stolen account unless he promptly initiates by notifying us of the account suspension and receiving a message from Tamara stating that the account is closed.',
  },
  {
    type: 'text',
    content:
      '<strong>4.5</strong> Since it is not permissible to transfer or transferring user accounts, therefore, you acknowledge and agree to return to Tamara the value of any transaction using your account, which is not valid, authorized or applicable process according to the law, and that happened by you or by any person who has access to the site Online, services, or otherwise, through the use of the username or password specified by you, and even whether or not you have allowed such access.',
  },
  {
    type: 'text',
    content:
      '<strong>4.6</strong> If Tamara has (and at its absolute discretion) doubts that any of the information it provided is incorrect, inaccurate, incomplete or not up-to-date, without prejudice to any other rights and remedies guaranteed by Tamara, in accordance with these terms and conditions or pursuant to the Applicable laws, so we have the right to stop our services and stop your access to the website or its services, or limit or cut short such access.',
  },
  {
    type: 'text',
    content:
      "<strong>4.7</strong> Tamara may (in its absolute discretion and even at any time) make any inquiries it deems necessary (whether this is done directly or through a third party), as well as ask you to provide a response and with more information or documents, and without limiting what was previously stated. If you are an employer or registered on behalf of an employer, such information or documents may include a business license and other official company documents and/or documents that demonstrate any person's authority to act on your behalf. You acknowledge and agree to provide any information and/or documents to Tamara upon request. You further acknowledge and agree that if you are unable to do so, Tamara may, without any liability, limit, suspend or withdraw your access to the Website. We also reserve the right to cancel any unconfirmed or unverified accounts or accounts that have not been active for a long time.",
  },
  {
    type: 'text',
    content:
      '<strong>4.8</strong> Upon completing the registration process from your side, you acknowledge and agree that you have read these terms and conditions, understand them and agree to be bound by them, as well as the privacy policy and all that may be amended from time to time, as the policy and its amendments - and under this agreement - are considered an integral part but are included in these terms and conditions.',
  },
  {
    type: 'subtitle',
    content: '5. The Services',
  },
  {
    type: 'text',
    content:
      '<strong>5.1</strong> Tamara is an electronic market designed to be a link as a comprehensive commercial center for many major shops by contracting with the owners of these sites or shops. Our goal is to provide a guide for major shops and give the customer the advantage of the option to buy now and pay later with the possibility of deferring payments over time in 3 or 6 easy payments.',
  },
  {
    type: 'text',
    content:
      '<strong>5.2</strong> The Tamara website displays products provided and owned by independent merchants on their own platforms who have agreed to put a list of these products on the website. These merchants have agreed in writing with Tamara to provide the products under orders through their electronic platforms.',
  },
  {
    type: 'text',
    content:
      '<strong>5.3</strong> A service fee will be applied for Pay Next Month and Pay in 3 for select merchants. The amount of this fee will be clearly displayed during checkout. Please review your total amount before finalizing your purchase to ensure that you are aware of all charges.',
  },
  {
    type: 'subtitle',
    content: '6. Correspondence and electronic communication',
  },
  {
    type: 'text',
    content:
      '<strong>6.1</strong> When you create an account, you acknowledge and agree that you will communicate with us electronically. Therefore agree to receive periodic messages from us and the Tamara team will communicate with you via e-mail or may send you information via SMS, as well as posting notices on the website as part of the usual business administration, which is related to your use of the Services. You acknowledge and agree that your choice not to apply the said means of communication is a matter that will affect your use of the Services.',
  },
  {
    type: 'text',
    content:
      '<strong>6.2</strong> To ensure that we are able to communicate with you electronically, you agree to notify us immediately of any change to your email address or other information you provide to us. We will contact you accordingly, including your phone number, by updating identifying information and any other information related to your Tamara account as soon as possible and when necessary.',
  },
  {
    type: 'text',
    content:
      '<strong>6.3</strong> You acknowledge and agree that all agreements, notices, disclosures and other correspondences that we provide to you electronically are correspondences that satisfy any legal requirement that such correspondences be submitted in writing.',
  },
  {
    type: 'text',
    content:
      '<strong>6.4</strong> Tamara website will also ask you during the registration process to agree to send you e-mails or promotional notifications related to the website and its services, and you agree to receive SMS messages for each phone number you provide to Tamara. You acknowledge that you are the main user of the phone number you provided us, and you acknowledge that you are permitted to receive an SMS on the phone number you have provided to us. You also agree to notify us whenever you stop using a particular phone number and if at any time you decide or express that you do not want to receive promotional e-mails, you can choose not to receive them by clicking on the link at the bottom of any promotional e-mail message.',
  },
  {
    type: 'subtitle',
    content: '7. Intellectual property rights and trademarks',
  },
  {
    type: 'text',
    content:
      '<strong>7.1</strong> For all content on the Website, including in general but not limited to text, graphics, Tamara logos, buttons, images, audio clips, digital downloads, data compilations, and software. Such content is considered the property and even work of Tamara or its licensors. Such content is protected by copyright, trademark rights, patents, and other intellectual property rights and laws. The content collected on the Website is the exclusive property and copyright of Tamara and is protected by copyright, trademark rights, patents and other intellectual property rights and laws.',
  },
  {
    type: 'text',
    content:
      "<strong>7.2</strong> The Tamara mark and associated symbols are trademarks of Tamara, noting that Tamara's trademarks may not be used in connection with any product or service that is not offered on Tamara, or any product or service that disparages Tamara or harms its reputation.",
  },
  {
    type: 'text',
    content:
      '<strong>7.3</strong> The customer is prohibited from using any trademark or any intellectual property rights belonging to Tamara, from any part of the services, and is prohibited from reproducing or modifying the services or conducting any process of preparing, publishing, executing, sending, displaying, broadcasting or other means of exploiting the services unless Tamara permits or expressly authorizes it in writing. It is also not permissible to dismantle the services system or any reverse engineering or reconfiguration of it, or to link any part of the services to any reflective system or frame it or put any programs or texts for the purpose of removing any part of the services, indexing, erasing or performing other data extraction operations from it, or loading the operation process and/or functional work of any aspect of the services with undue loads, obstructing them, or attempting to gain access to them without permission to do so or work to harm the services or associated systems or networks.',
  },
  {
    type: 'subtitle',
    content: '8. Using the website',
  },
  {
    type: 'text',
    content:
      '<strong>8.1</strong> The customer is prohibited from using the Tamara website to advertise a product for himself or in the product review section (for restricted products) or in any other place on the site (as determined by our absolute choice) any posting for the following: any advertisement for the purpose of attracting or any advertisements or use vulgar language, obscenity, insults, cultural or religious abuse, any political or critical content, or material that may threaten the public interest or national security, or cause defamation, slander, libel, or any other content that may be offensive or obscenity or indecency.',
  },
  {
    type: 'subtitle',
    content: '9. Product lists and availability',
  },
  {
    type: 'text',
    content:
      "<strong>9.1</strong> Tamara will always work to provide you with the best experiences and even an outstanding level of service, as Tamara makes every effort to ensure that the supplier's products are available. However, Tamara does not bear any responsibility in the event that any products are not available with any merchant and these products are displayed on the website.",
  },
  {
    type: 'subtitle',
    content: '10. After-sales service for products:',
  },
  {
    type: 'text',
    content:
      '<strong>10.1</strong> The products sold through this website that do not bear the trade name of Tamara are products for which services are provided and supported by merchants, their manufacturers or their local agents only, as well as their suppliers, in accordance with the terms and conditions associated with each product. Nor does Tamara give any warranty of any kind for the products sold on the Website. For this reason, please contact merchants when you need technical support, customer service or after-sales service regarding their products.',
  },
  {
    type: 'subtitle',
    content: '11. The Payments:',
  },
  {
    type: 'text',
    content:
      '<strong>11.1</strong> Once you have created an account with Tamara in accordance with this Agreement, Tamara grants you the ability to request the use of the Tamara Payment Services when you choose to pay for goods or services using the Tamara Payment Services payment option at the relevant merchant or on the website of the merchant platform.',
  },
  {
    type: 'text',
    content:
      '<strong>11.2</strong> Tamara Payment Services allow you to purchase goods or services from a merchant or merchant platform with payment at a later date based on the payment terms specified during the payment process and these payment terms may include late amounts as specified in the payment process by entering into this agreement. You agree and acknowledge that you have understood and accepted all fees associated with your purchase order as specified in the payment process, with respect to the late amount, you undertake to pay it to Tamara, provided that Tamara gives it in charity under the supervision of the Shariah Committee.',
  },
  {
    type: 'text',
    content:
      "<strong>11.3</strong> Once you have chosen Tamara's Payment Service at the merchant's point of sale during the payment process, you will be asked to choose from among a set of payment terms that will become effective and binding between you and Tamara in relation to this purchase order. Tamara provides different payment methods on the website, including electronic payment through credit cards.",
  },
  {
    type: 'text',
    content:
      '<strong>11.4</strong> Tamara reserves the right to make any change or modification to the payment method or its provision.',
  },
  {
    type: 'text',
    content:
      '<strong>11.5</strong> Tamara provides electronic payment services through third-party service providers, knowing that Tamara does not store any data related to credit cards. Tamara does not bear any responsibility for any error, damage or any similar matter that the customer may be exposed to as a result of using the electronic payment method. This is the responsibility of the third party service provider.',
  },
  {
    type: 'text',
    content:
      '<strong>11.6</strong> The customer must ensure that there is sufficient financial coverage in the relevant account, so that orders can be covered, and must comply with the credit card transaction limits.',
  },
  {
    type: 'text',
    content:
      '<strong>11.7</strong> Under this Agreement, you (the Customer) agree and authorize Tamara to withdraw the amount from the card account stored in your account (the Customer Account) with Tamara on the date due for payment. In the event that the process is rejected for lack of funds covering the premium, an attempt will be made every two days (day yes and day no) until the full amount is paid.',
  },
  {
    type: 'text',
    content:
      '<strong>11.8</strong> Tamara may impose additional fees on users when making the payment process electronically.',
  },
  {
    type: 'text',
    content:
      '<strong>11.9</strong> Tamara may (in its absolute discretion and even at any time) make any inquiries it deems necessary (either directly or through third parties), and may also ask you to provide it with more information or documents, including in general but not limited to any information or documents needed to verify your identity and/or financial solvency. You acknowledge and agree to provide any information and/or documents to Tamara upon request. You also acknowledge and agree that if you are unable to do so, Tamara may, without any liability to it, cancel the transaction or limit or suspend your access to the Website and/or withdraw your membership from the Website.',
  },
  {
    type: 'text',
    content:
      '<strong>11.10</strong> You hereby agree to acknowledge your financial ability to fulfill your financial obligations towards Tamara, you also agree that Tamara has the right to cooperate with the merchant in the event where you fail to fulfill your obligations to pay or delay the payment; such cooperation includes but not limited to (suspend the subscription/ service, seizing the product/ goods) until the payments are fulfilled.',
  },
  {
    type: 'text',
    content:
      '<strong>11.11</strong> You hereby agree that you understand and bear the potential consequences when you use the Finance Service in violation of the agreed terms. You agree that Tamara has the right (at her absolute discretion) to notify the Saudi Credit Bureau (“SIMAH”) in the event of your delay or inability to pay.',
  },
  {
    type: 'text',
    content:
      "<strong>11.12</strong> You hereby agree that you are the true beneficiary of this agreement and that you do not use Tamara's services for any money laundering.",
  },
  {
    type: 'subtitle',
    content: '12. Refund of Payments:',
  },
  {
    type: 'text',
    content:
      '<strong>12.1</strong> Tamara is not liable to you in connection with any refund of payments and while Tamara may play a role in facilitating refunds and refund of payments between you and the Merchant or the Merchant Platform at its sole discretion, such role does not imply any liability in connection with the refund of payments.',
  },
  {
    type: 'subtitle',
    content: '13. Confidentiality and Privacy:',
  },
  {
    type: 'text',
    content:
      '<strong>13.1</strong> (Tamara) is committed to all reasonable professional methods in maintaining the confidentiality of credit information and data in its possession, and not using or exchanging them between it and related persons and parties except within the limits and according to what is stated in the credit information regulation and its executive by-laws.',
  },
  {
    type: 'text',
    content:
      '<strong>13.2</strong> You hereby agree to provide any information, including identification information or documentation reasonably required by Tamara to verify your identity in connection with your Tamara account or any use of Tamara Payment Services, and you authorize us to make any inquiries we believe are necessary in order to verify your identity. Tamara reserves the right to close your Tamara account or suspend or limit your access to Tamara Payment Services if we are unable to obtain or verify any such information to our satisfaction.',
  },
  {
    type: 'text',
    content:
      '<strong>13.3</strong> You hereby consent and authorize Tamara to use any or all of your personally identifiable information and personal data collected through Tamara websites, platforms or mobile applications or merchants from time to time and may be used or disclosed to other people. This may include sharing your identifying information and any other information with third parties for the purposes of credit verification, anti-money laundering or other similar checks or for any other purpose that Tamara considers necessary in order to enable Tamara to provide payment services to you and to comply with all applicable laws and regulations.',
  },
  {
    type: 'text',
    content:
      '<strong>13.4</strong> You hereby agree to this Agreement and when accessing or using the Tamara websites or mobile applications, you hereby agree to the confidentiality policy, knowing that your personal information is collected and understanding how it will be handled.',
  },
  {
    type: 'text',
    content:
      "<strong>13.5</strong> If you do not agree with our policies and practices, you will not be able to use Tamara's websites or mobile applications and please do not continue to use our services.",
  },
  {
    type: 'text',
    content:
      '<strong>13.6</strong> Customers have the right to withdraw their consent to the processing of their personal data at any time, subject to contractual and statutory restrictions and written notice.',
  },
  {
    type: 'text',
    content:
      '<strong>13.7</strong> Tamara does not allow the customer (contractor with Tamara) to disclose to third parties any information received by him under this agreement or a service contract concluded with Tamara. Rather, any information related to Tamara’s business should not be accessed in a confidential manner, within the limits that may negatively affect Tamara’s business, and the customer shall be responsible for compensating Tamara for any loss of business or reputation, if this occurs as a result of any act that occurs from the Customer.',
  },
  {
    type: 'subtitle',
    content: '14. Limitation of Liability:',
  },
  {
    type: 'text',
    content:
      "<strong>14.1</strong> Tamara is an independent platform, and does not participate in transactions between customers, merchants, sellers or other related dealings. Therefore Tamara is not in any way responsible for any situation related to merchants and is not responsible for any failure related to the merchants' products or product model, mark, reliability, adequacy, originality, availability or legality.",
  },
  {
    type: 'text',
    content:
      '<strong>14.2</strong> Third-party merchants are considered independent of this agreement and are independent service providers who are only contracting with Tamara, and they may not be considered employees of Tamara, or its representatives or agents. Also, Tamara does not perform the tasks herself, but rather manages the process of executing the tasks through its electronic platform, by providing a communication process between the customer and the merchant. Merchants are fully responsible for all dealings that take place between them and customers or other related dealings, and in the event of a dispute between any of the participants in such transactions, each of the customers, users and merchants undertake to release Tamara from any liability arising from or related to any disputes between any parties in any way. The undertaking to release Tamara (and its agents and employees) from claims, demands, liabilities and indemnities of any kind or nature, known or unknown, disclosed or undisclosed, arising out of or in any way related to such disputes.',
  },
  {
    type: 'text',
    content:
      '<strong>14.3</strong> By agreeing to this agreement, you acknowledge your knowledge and understanding of the possibility of risks arising from merchants or errors from them or from third party service providers. Therefore the use of the services is the responsibility of the customer and according to his decision, and Tamara does not bear any responsibility towards it. 14.4 Tamara shall not be liable to you or to any other person for any direct, indirect, incidental, special, penal, punitive or consequential damages that may arise, even if Tamara has been informed of the possibility of such damages, and Tamara shall not be liable for any damages, obligations or losses that you incur, arising from your use of or reliance on the Services, or as a result of your inability to access or use the Services, or from any transaction or relationship that arose between you and any merchant, and even if Tamara indicated the possibility of such damages occurrence. Tamara is also not responsible for any delay or failure in implementation, nor will it be held responsible in the event that the merchant may not have a professional or specialized permit to operate.',
  },
  {
    type: 'text',
    content:
      "<strong>14.4</strong> The services are provided as offered and as available, and Tamara is exempted and even disclaimed from all representations and warranties, express, implied, or statutory that are not expressly stated in these conditions, including the implied warranties regarding the seller’s ability and suitability of his services for a particular purpose and non-violation of them, Tamara does not make any representation or warranty about the reliability, quality, sustainability, availability or original owner of the services or goods or any services ordered through the use of Tamara's services, nor does Tamara guarantee that the services will be uninterrupted or error-free. To the fullest extent permitted by applicable law, you hereby acknowledge and agree that you assume all liability arising from your use of any of the services offered by Tamara.",
  },
  {
    type: 'text',
    content:
      '<strong>14.5</strong> The information on the website is provided for general purposes only. As for the information provided by Tamara, we make every effort to keep the information up-to-date and correct, but we do not make any representations or warranties of any kind, whether in oral or implied, in terms of the completeness, accuracy, reliability, suitability or availability of the Website, information, services or related advertisements or graphics contained on the Website for any purpose, and therefore your reliance on such information is at your own private risk completely.',
  },
  {
    type: 'text',
    content:
      '<strong>14.6</strong> For security and performance reasons, all accounts registered on Tamara are considered to be constantly monitored.',
  },
  {
    type: 'text',
    content:
      '<strong>14.7</strong> Tamara shall not be liable for any delay, interruption or failure in the provision of the Services, if caused by a force majeure event or similar event beyond our control or control that would prevent or impede the provision of the Service.',
  },
  {
    type: 'text',
    content:
      '<strong>14.8</strong> You hereby acknowledge and agree to indemnify and hold Tamara and any of its affiliates, officers, directors, employees and agents from and against any and all claims, liabilities, damages, losses, expenses or expenses, including without limitation, legal and accounting fees arising out of or in any way related to the following:',
  },
  {
    type: 'list',
    content: [
      "(a) Your access to, use of, or inability to use Tamara's Account or  Tamara Payment Services.",
      '(b) Your negligence or misconduct.',
      '(c) Your violation of any applicable law.',
      '(d) Your failure to provide and maintain true, accurate, current and  complete information in connection with your Tamara account.',
    ],
  },
  {
    type: 'text',
    content:
      '<strong>14.9</strong> If you do not agree to any of these terms and conditions in the agreement, you must not access the site and not use the Tamara Services.',
  },
  {
    type: 'subtitle',
    content: '15. Compensation:',
  },
  {
    type: 'text',
    content:
      '<strong>15.1</strong> You acknowledge and agree to indemnify and ward off damage from Tamara, its affiliate entities, sponsors, partners, directorate, liability, employees and reimbursement of all losses to her/them as well as the value of damages, liabilities, claims, judgments, settlements, fines, costs and expenses (including any expenses, legal fees, investigation costs, and attorneys’ fees). In case Tamara suffers any damages caused by you or if it arises or is related to your breach of the Agreement, these Terms and Conditions, the Privacy Policy or your or third party (by you) use of the Services.',
  },
  {
    type: 'subtitle',
    content: '16. Notifications:',
  },
  {
    type: 'text',
    content:
      '<strong>16.1</strong> All notifications and other communications under this Agreement shall be in writing by correspondence to the Tamara e-mail shown on the Tamara website in the event you wish to notify or otherwise communicate with Tamara, via the e-mail address or telephone number you have provided to Tamara In accordance with the terms of this Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>16.2</strong> To ensure that we can communicate with you electronically, you agree to notify us immediately of any change in your email address or other information you provide to us and we will contact you accordingly including your phone number, by updating identifying information and any other information related to your Tamara account as soon as possible practically and when necessary.',
  },
  {
    type: 'subtitle',
    content: '17. Applicable Laws and Jurisdiction:',
  },
  {
    type: 'text',
    content:
      '<strong>17.1</strong> The rights and obligations of the parties stipulated in the terms and conditions of this Agreement shall be governed by and interpreted in accordance with the provisions of the laws of Kuwait.',
  },
  {
    type: 'text',
    content:
      '<strong>17.2</strong> By agreeing to this Agreement, you undertake to submit unconditionally to the exclusive jurisdiction of the Kuwaiti courts for any dispute arising out of or related to the Agreement and any of these terms and conditions, and you also acknowledge and undertake to waive your right to take any legal actions anywhere else.',
  },
  {
    type: 'subtitle',
    content: '18. Cooperation in investigations and inquiries:',
  },
  {
    type: 'text',
    content:
      '<strong>18.1</strong> You hereby agree to cooperate with Tamara to the fullest extent permitted by applicable law and regulations in the Kingdom of Saudi Arabia, including agreeing to answer in writing any questions or provide information to assist Tamara in conducting any internal investigation or inquiry.',
  },
  {
    type: 'text',
    content:
      '<strong>18.2</strong> Under this agreement, you acknowledge that you agree that Tamara disclose information about you and your aforementioned account or any other account with the authorized representative of the Saudi Credit Bureau (SIMAH) through the concluded membership agreement and the approved business rules for the exchange of information and / or to any other party that approved by the Saudi Central Bank (SAMA).',
  },
  {
    type: 'subtitle',
    content: '19. Independence and Separability of the Terms and Conditions:',
  },
  {
    type: 'text',
    content:
      '<strong>19.1</strong> If any term or provision in this Agreement is determined to be ineffective, unenforceable or invalid, then only that term or provision shall be deemed invalid without affecting in any way the rest of the terms and conditions that remain in effect and have all their effects.',
  },
  {
    type: 'subtitle',
    content: '20. Validity and termination of the agreement:',
  },
  {
    type: 'text',
    content:
      '<strong>20.1</strong> This Agreement shall become effective on the date on which you click to indicate your acceptance of its terms and shall remain in effect and will be effective for your successors.',
  },
  {
    type: 'text',
    content:
      '<strong>20.2</strong> This Agreement may be terminated at any time by either party for any or no reason',
  },
  {
    type: 'text',
    content:
      '<strong>20.3</strong> If Tamara decides to terminate this Agreement, it will notify you by sending a notification to the email address you have provided to Tamara. You hereby agree and acknowledge that Tamara has the absolute right to terminate this Agreement with or without reason and has no obligation to notify you of the reason for the termination of the Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>20.4</strong> You may terminate this Agreement by closing your Tamara account by following the instructions on the Tamara website, and for the avoidance of doubt you will remain responsible for all obligations relating to your Tamara account even after it is closed and you terminate this Agreement.',
  },
  {
    type: 'text',
    content:
      '<strong>20.5</strong> You may request the closure of your Tamara Account at any time by following the instructions on the Tamara website if there are no amounts owed by you to Tamara in connection with the Tamara Payment Services and you will remain responsible for all obligations relating to the Tamara Account even after its closure.',
  },
  {
    type: 'subtitle',
    content: '21. The Entire Agreement:',
  },
  {
    type: 'text',
    content:
      '<strong>21.1</strong> The agreement and all its terms and conditions represent the entire agreement and what has been agreed and understood between you and Tamara. It also includes any update that may occur to it from time to time and what is published about it on our website. This agreement cancels and copies any of the foregoing from other agreements of any kind.',
  },
]
